import { FilterBar } from '@/components/ui/FilterBar';
import * as React from 'react';

const ENABLED_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Enabled' },
  { value: 'false', label: 'Disabled' },
];

const MANDATORY_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Mandatory' },
  { value: 'false', label: 'Not Mandatory' },
];

export interface FiltersFiltersProps {
  searchTerm: string;
  selectedEnabled: string;
  selectedIsMandatory: string;
  onSearchChange: (value: string) => void;
  onEnabledChange: (value: string) => void;
  onIsMandatoryChange: (value: string) => void;
  onClearFilters: () => void;
}

export const FiltersFilters: React.FC<FiltersFiltersProps> = ({
  searchTerm,
  selectedEnabled,
  selectedIsMandatory,
  onSearchChange,
  onEnabledChange,
  onIsMandatoryChange,
  onClearFilters,
}) => {
  return (
    <FilterBar
      searchPlaceholder='Search filters by name...'
      searchValue={searchTerm}
      onSearchChange={onSearchChange}
      filters={[
        { key: 'enabled', label: 'Status', options: ENABLED_OPTIONS },
        { key: 'isMandatory', label: 'Mandatory', options: MANDATORY_OPTIONS },
      ]}
      filterValues={{
        enabled: selectedEnabled,
        isMandatory: selectedIsMandatory,
      }}
      onFilterChange={(key, value) => {
        if (key === 'enabled') onEnabledChange(value);
        if (key === 'isMandatory') onIsMandatoryChange(value);
      }}
      onClearAll={onClearFilters}
      activeFilters={[
        { label: 'Search', value: searchTerm, color: 'blue' },
        {
          label: 'Status',
          value: selectedEnabled
            ? selectedEnabled === 'true'
              ? 'Enabled'
              : 'Disabled'
            : '',
          color: 'green',
        },
        {
          label: 'Mandatory',
          value: selectedIsMandatory
            ? selectedIsMandatory === 'true'
              ? 'Yes'
              : 'No'
            : '',
          color: 'yellow',
        },
      ]}
    />
  );
};
